import { useLocation } from 'react-router-dom';

export const useContextualNavigation = () => {
  const location = useLocation();
  
  const isAdminRoute = location.pathname.includes('/admin/');
  
  const getListRoute = (entity) => {
    return isAdminRoute ? `/admin/${entity}` : `/${entity}`;
  };
  
  return { getListRoute, isAdminRoute };
};